<template>
  <section class="request-payment-step">
    <a-alert v-if="isLoading" type="info" show-icon message="Loading payment request" />
    <a-alert
      v-if="error"
      type="error"
      show-icon
      message="The payment request could not be completed"
      :description="error"
    />

    <template v-if="payment">
      <payment-info-main :payment-info="payment" />

      <p class="review-note">Confirming the transfer sends this payment request to the selected client.</p>
    </template>
  </section>
</template>

<script>
import { Alert } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import StripeNotificationMixin from '../../mixins/StripeNotificationMixin'
import PaymentInfoMain from '../info/payment-info-main.vue'

const { mapActions: paymentActions } = createNamespacedHelpers('payment')

export default {
  mixins: [StripeNotificationMixin],
  components: {
    'a-alert': Alert,
    'payment-info-main': PaymentInfoMain
  },
  props: {
    paymentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      paymentRequest: null,
      isLoading: false,
      error: ''
    }
  },
  computed: {
    payment() {
      return this.paymentRequest || null
    },
    stepState() {
      return {
        canContinue: Boolean(this.payment) && !this.isLoading,
        loading: this.isLoading,
        label: 'Confirm transfer'
      }
    }
  },
  watch: {
    stepState: {
      handler(state) {
        this.$emit('state-change', state)
      },
      immediate: true
    }
  },
  mounted() {
    this.loadPayment()
  },
  methods: {
    ...paymentActions(['getPayment', 'doPaymentRequestAction']),

    async loadPayment() {
      this.isLoading = true
      this.error = ''
      try {
        this.paymentRequest = await this.getPayment({ payment_id: this.paymentId })
      } catch (error) {
        this.error = typeof error === 'string' ? error : error?.message
      } finally {
        this.isLoading = false
      }
    },
    async confirmTransfer() {
      if (!this.stepState.canContinue) return
      this.isLoading = true
      this.error = ''
      try {
        await this.doPaymentRequestAction({ payment_id: this.paymentId, action: 'confirm_transfer' })
        this.showNotification('success', 'Payment request sent')
        this.$emit('completed')
      } catch (error) {
        this.error = typeof error === 'string' ? error : error?.message
        this.showErrorNotification(error, 'The payment request could not be sent. Try again.')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.request-payment-step {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.review-note,
.review-card span {
  color: var(--text-secondary);
}
.review-note {
  margin: 0;
}
.review-card {
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px 24px;
  border: 1px solid var(--border-color-base);
  border-radius: 8px;
}
.review-card > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.review-card strong {
  text-align: right;
}
</style>
